module.exports = __webpack_public_path__ + "img/sld_scb_20_t1_b1_green.782c6317.svg";